import React from 'react'
import ReactDOM from 'react-dom'
import { ToastContainer } from 'react-toastify'

import './Notify.scss'

const Notify = () =>
  ReactDOM.createPortal(<ToastContainer theme="dark" />, document.getElementById('notifications-dom-root'))

export default Notify
